import React from 'react';
import styled from 'styled-components';
import { ArrowRightIcon } from 'components/Brand/Icons';
import { Link } from 'gatsby';

const ArrowStyles = (color) => `div {
    > * {
      margin-bottom: 0px;
      color: ${color}
    }
    svg {
      stroke: ${color};
      height: 18px;
      width: 18px;
      vertical-align: middle;
      margin-left: 7px;
    }
  }`;

const CardContainer = styled.div`
  width: 289px;
  height: 360px;
  border: 4px solid white;
  border-radius: 8px;
  position: relative;
  cursor: pointer;

  &:hover div:nth-child(2) {
    opacity: 1;
  }
`;

const MainContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;

  ${ArrowStyles('white')}
`;

const ImageContainer = styled.div`
  background: linear-gradient(to bottom, transparent 50%, black 100%);
  flex-grow: 1;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const HoverContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  position: absolute;
  top: 0;
  opacity: 0;
  transition: opacity 0.2s ease;

  ${ArrowStyles('black')}
`;

const StyledTitleContainer = styled.div`
  padding: 12px;
  background-color: ${({ darkBG }) => (darkBG ? 'var(--darkest)' : 'var(--white)')};
`;

const Gradient = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, transparent 85%, var(--darkest) 100%);
`;
const TitleContainer = ({ name, darkBG }) => (
  <StyledTitleContainer darkBG={darkBG}>
    <h4>{name}</h4>
    <p>
      ServiceTitan Super Ambassador
      <ArrowRightIcon />
    </p>
  </StyledTitleContainer>
);
const ContentfulAmbassadorCard = ({ ambassadorName, hoverContent, ambassadorImage, url }) => {
  return (
    <Link href={url} className="inline-block">
      <CardContainer image={ambassadorImage.file.url}>
        <MainContent>
          <ImageContainer>
            <img src={ambassadorImage.file.url} width="100%" alt={ambassadorName} />
            <Gradient />
          </ImageContainer>

          <TitleContainer name={ambassadorName} darkBG />
        </MainContent>
        <HoverContent>
          <p className="p-3">{hoverContent.hoverContent}</p>
          <TitleContainer name={ambassadorName} />
        </HoverContent>
      </CardContainer>
    </Link>
  );
};

export default ContentfulAmbassadorCard;
